module.exports = __webpack_public_path__ + "static/media/Charing Cross Pavillion installation ceremony of Victoria_s statue.3baf36bb.jpg";